import React from 'react';
import './table.scss'

const Table = ({className = '', children}) =>
    <table className={`table ${className}`}>
        {children}
    </table>
;

export default Table;